import React, { useRef } from 'react';
import Webcam from 'react-webcam';

export default function WebCome({ handleBackground, startRecording, stopRecording, isRecording, videoRef }) {
  // Create a separate webcamRef for the Webcam component
  const webcamRef = useRef(null);
  
  // Modify startRecording to use the webcamRef instead
  const handleStartRecording = () => {
    // Pass the current webcam video element to the videoRef
    if (webcamRef.current && webcamRef.current.video) {
      videoRef.current = webcamRef.current.video;
      startRecording();
    }
  };

  return (
    <div className="relative w-full sm:h-[446px] sm:w-[694px] max-w-md aspect-video rounded-2xl overflow-hidden shadow-lg mx-auto">
      {/* Video Feed */}
      <Webcam
        ref={webcamRef}
        audio={false}
        id="localVideo"
        screenshotFormat="image/jpeg"
        videoConstraints={{
          width: 1280,
          height: 720,
          facingMode: 'user',
        }}
        className="w-full h-full object-cover"
      />
      {/* Live/Off Status Badge */}
      <button
        onClick={isRecording ? stopRecording : handleStartRecording}
        className="absolute top-4 left-4 bg-gray-800 bg-opacity-60 text-white flex items-center px-3 py-1 rounded-full focus:outline-none"
      >
        <span className={`inline-block w-3 h-3 rounded-full mr-2 ${isRecording ? 'bg-red-600' : 'bg-gray-400'}`}></span>
        <span className="text-sm font-medium uppercase">
          {isRecording ? 'Live' : 'Off'}
        </span>
      </button>
      {/* Record Toggle Button */}
      <button
        onClick={isRecording ? stopRecording : handleStartRecording}
        className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-700 p-3 rounded-full shadow-lg focus:outline-none"
      >
        <div className="w-8 h-8 rounded-full bg-black flex items-center justify-center">
          <div className={`rounded-full ${isRecording ? 'bg-red-600' : 'bg-green-400'} w-4 h-4`}></div>
        </div>
      </button>
    </div>
  );
}